function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-301.47 -82.386)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 301.47 82.386)",
  fill: "#22323f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m38.615 0h-22.23c-9.0346 0-16.385 7.3502-16.385 16.385v22.23c0 9.0346 7.3502 16.385 16.385 16.385h22.23c9.0346 0 16.385-7.3502 16.385-16.385v-22.23c-1e-4 -9.0346-7.3503-16.385-16.385-16.385zm10.852 38.615c0 5.9932-4.8586 10.852-10.852 10.852h-22.23c-5.9932 0-10.852-4.8586-10.852-10.852v-22.23c0-5.9933 4.8586-10.852 10.852-10.852h22.23c5.9932 0 10.852 4.8585 10.852 10.852z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.5 13.275c-7.8436 0-14.225 6.3813-14.225 14.225 0 7.8435 6.3813 14.225 14.225 14.225 7.8437 0 14.225-6.3813 14.225-14.225 0-7.8437-6.3813-14.225-14.225-14.225zm0 22.917c-4.8004 0-8.6919-3.8914-8.6919-8.6919s3.8916-8.692 8.6919-8.692c4.8005 0 8.692 3.8915 8.692 8.692 0 4.8004-3.8916 8.6919-8.692 8.6919z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41.752 16.79c1.8825 0 3.4085-1.526 3.4085-3.4085s-1.526-3.4085-3.4085-3.4085c-1.8824 0-3.4085 1.526-3.4085 3.4085s1.5261 3.4085 3.4085 3.4085z"
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.552mm",
    height: "14.552mm",
    viewBox: "0 0 14.552 14.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.eb8bb44a.svg";
export { ForwardRef as ReactComponent };